import { ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MemberRoutes } from './app.route.member';
import { PublicRoutes } from './app.route.public';

export const routing: ModuleWithProviders = RouterModule.forRoot([
    ...MemberRoutes,
    ...PublicRoutes,
]);



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/app.routing.ts